import axios from "axios"
import router from "@/router"
import config from "./config"
import qs from "qs"
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import {encrypt,decrypt} from "../utils/kN"
import {
    Message,
    Loading
} from "element-ui"
import store from "@/store"


axios.defaults.timeout = 1000*60*5
axios.defaults.withCredentials = true
const BaseUrl = config.baseUrl
axios.defaults.headers['Content-Type'] = "application/json;charset=utf-8"
let loading

// NProgress.configure({ showSpinner: false })
axios.interceptors.request.use((config) => {
    // if(config.url !== "/shareData/getShareDataList" && config.url !== "/ythAddress/getAllCity") {  // 统一给请求添加loading, 下拉搜素过滤掉，防止弹窗闪动
    //     loading = Loading.service({
    //         fullscreen: true
    //     })
    // }
    // console.log(config)
    // console.log(config.data)
    if(config && config.data && config.url!=='/upload'){
        config.data  = encrypt(JSON.stringify(config.data))
            .replace(/\+/g, "_PLUS_")
            .replace(/\//g, "_SLASH_")
            .replace(/=/g, "_EQUAL_");
    }

    if(config.url!=='/upload'){
        config.url = "/web"+config.url
    }
    NProgress.start()
    config.headers.token = localStorage.getItem('token') || ""
    config.headers.source = "pc"
    if (!config.url.includes("http")) {
        config.url = BaseUrl + config.url
    }
    return config
}, error => {
    Message({
        showClose: true,
        message: error,
        type: "warning"
    });
    return Promise.reject(error)
})
axios.interceptors.response.use(response => {
    // loading.close()
    // console.log(response)
    const str = "QVldp0YU6M0meZmBC71EVmxxWnfNqpdXTbiAIpD1n14SymiWNe7ml0S9hUDWTzngeWNYSr1HYpU0znBHFkeSR8ZctbHzHumSOTXdqcgAbnQ="
    console.log(decrypt(str))
    try{
        if(typeof response.data ==="string"){
            response.data = JSON.parse(decrypt(response.data))
        }else if(response.message === "未登录"){
            throw new Error()
        }
        console.log(response)
    }catch (e) {
        console.log("catch",response)
        Message({
            message: "服务器错误！解密失败！",
            type: "error",
            duration: 2000
        })

        return Promise.resolve(e)
    }
    NProgress.done();
    if (response.status === 200 && response.data.code === 400) {
        Message({
            message: response.data.msg,
            type: "error",
            duration: 2000
        })
    }
    // if (response.status === 200 && response.data.code === 500){
    //     Message({
    //         message: response.data.msg,
    //         type: "error",
    //         duration: 2000
    //     })
    //     store.commit("logout")
    //     router.push({
    //         path: '/login',
    //         query: {
    //             redirect: router.currentRoute.fullPath
    //         }
    //     })
    //     return Promise.reject(response)
    // }
    if (response.status === 200 && response.data.code === 401) {
        Message({
            message: response.data.msg,
            type: "error",
            duration: 2000
        })
        store.commit("logout")
        router.push({
            path: '/login',
            query: {
                redirect: router.currentRoute.fullPath
            }
        })
        return Promise.reject(response)
    }else if (response.status == 200 && response.data.code === 255) {
        return Promise.resolve(response)
    } else if (response.status == 200 && response.data && response.data.code && response.data.code !== 200) {
        Message({
            message: response.data.msg,
            type: "error",
            duration: 2000
        })
        // return Promise.reject(response)
    }
    return Promise.resolve(response)
}, error => {
    console.log("error===",error.response)
    // loading.close()
    NProgress.done();
    try {
        const responseData = JSON.parse(decrypt(error.response.data))
        Message({
            showClose: true,
            message: responseData.msg?responseData.msg:"服务器异常，请联系管理员",
            type: "error"
        });
    }catch (e) {
            Message({
                showClose: true,
                message: "出错了，请联系管理员",
                type: "error"
            });
    }
    // if(error.message === "Request failed with status code 500"){
    //     Message({
    //         showClose: true,
    //         message: "请重新登录",
    //         type: "error"
    //     });
    //     store.commit("logout")
    //     router.push({
    //         path: '/login',
    //         query: {
    //             redirect: router.currentRoute.fullPath
    //         }
    //     })
    //     return Promise.reject(error)
    // }

    if (error.response && (error.response.status == 402 || error.response.status == 401)) {
        store.commit("logout")
        router.push({
            path: '/login',
            query: {
                redirect: router.currentRoute.fullPath
            }
        })
    }

    return Promise.reject(error)
})

export default axios